import { newSessionArray, session } from "./session";
import { newStaffArray, staff } from "./staff";
import {newScheduleArray, Schedule} from "./schedule";
import {newRoomArray, Room} from "./rooms"
import {newTimeSlotArray, TimeSlot} from "./timeSlots"

export type EventsListItem={
    Id: string;
    Name: string;
    StartDate: string;
    EndDate: string;
    Status: string;
    LocationDescription: string;
    KeynoteSelected: boolean;
    SessionsSelected: boolean;
    CallForSpeakerOpen:boolean;
    IsWorkshopSessionAllowed:boolean;
    Price: number;
    RegisteredUserCount?: number;
};

export type EventInfo={
    Id: string;
    Name: string;
    StartDate: string;
    EndDate: string;
    Status: string;
    Address1: string;
    Address2: string;
    City: string;
    State: string
    Zip : string;
    LocationDescription: string;
    KeynoteSelected: boolean;
    SessionsSelected: boolean;
    CallForSpeakerOpen:boolean;
    IsWorkshopSessionAllowed:boolean;
    Year: number;
    Sessions: session[];
    Staff: staff[];
    Price: number;
    Rooms: Room[];
    TimeSlots: TimeSlot[];
    ScheduleSlots: Schedule[];
};
export function newEventInfo():EventInfo{
    return {
        Id: "",
        Name: "",
        StartDate: "",
        EndDate: "",
        Status: "",
        Address1: "",
        Address2: "",
        City: "",
        State: "",
        Zip : "",
        LocationDescription: "",
        KeynoteSelected: false,
        SessionsSelected: false,
        CallForSpeakerOpen:false,
        IsWorkshopSessionAllowed:false,
        Year: 0,
        Sessions: newSessionArray(),
        Staff: newStaffArray(),
        Price: 0,
        Rooms: newRoomArray(),
        TimeSlots: newTimeSlotArray(),
        ScheduleSlots: newScheduleArray(),
    };
}